<header class="copilot-drawer__header d-flex align-items-center gap-2 px-3 py-2 border-bottom font-13">
  <button
    #back
    type="button"
    class="btn btn-link p-0 pe-2 font-12 fw-medium text-decoration-none"
    [attr.aria-label]="'attendance.copilot.drawer.backLabel' | translate"
    (click)="closed.emit()"
  >
    <i class="ri-arrow-left-s-line align-middle"></i>{{ "attendance.copilot.drawer.back" | translate }}
  </button>

  <div class="btn-group gap-1 ms-auto" role="group" [attr.aria-label]="'attendance.copilot.drawer.panes' | translate">
    <button
      type="button"
      class="btn btn-sm font-12"
      [class.btn-primary]="pane === 'insight'"
      [class.btn-outline-secondary]="pane !== 'insight'"
      [attr.aria-pressed]="pane === 'insight'"
      (click)="paneChange.emit('insight')"
    >
      {{ "attendance.copilot.insight.title" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-sm font-12"
      [class.btn-primary]="pane === 'actions'"
      [class.btn-outline-secondary]="pane !== 'actions'"
      [attr.aria-pressed]="pane === 'actions'"
      (click)="paneChange.emit('actions')"
    >
      {{ "attendance.copilot.actions.title" | translate }}
      <span class="badge rounded-pill bg-light text-dark ms-1">{{ pendingCount$ | async }}</span>
    </button>
  </div>
</header>

<div class="copilot-drawer__body" role="region" [attr.aria-label]="titleKey() | translate">
  @if (pane === "insight") {
    <attendance-copilot-insight [attendanceClosed]="attendanceClosed" />
  } @else {
    <attendance-copilot-actions [attendanceClosed]="attendanceClosed" />
  }
</div>
